import BaseComponent from '../base-component/base-component'
import FloatElement from './float-element'
import { Nullable } from '../../types/common'

class TooltipTrigger extends BaseComponent {
  connectedCallback(): void {
    this.addEventListener('mouseenter', this.handleMouseEnter)
    this.addEventListener('mouseleave', this.handleMouseLeave)
  }

  disconnectedCallback(): void {
    this.removeEventListener('mouseenter', this.handleMouseEnter)
    this.removeEventListener('mouseleave', this.handleMouseLeave)
  }

  handleMouseEnter = (): void => {
    if (!this.floatElement) {
      return
    }

    this.floatElement.show()
  }

  handleMouseLeave = (): void => {
    if (!this.floatElement) {
      return
    }

    this.floatElement.hide()
  }

  setExpand(isExpanded: boolean): void {
    this.setAttribute('data-aria-expanded', isExpanded ? 'true' : 'false')
  }

  get floatElement(): Nullable<FloatElement> {
    if (!this.dataset.floatElementId) {
      return null
    }

    return document.getElementById(this.dataset.floatElementId)
  }
}

export default TooltipTrigger
